import { render, staticRenderFns } from "./HeaderInformationNavigationTalentpool.vue?vue&type=template&id=1db2d1ba&scoped=true"
import script from "./HeaderInformationNavigationTalentpool.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationTalentpool.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationTalentpool.vue?vue&type=style&index=0&id=1db2d1ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2d1ba",
  null
  
)

export default component.exports